module.exports = __webpack_public_path__ + "img/40_38_071_950.2e3f0764.jpg";